import React from 'react';
import { Input } from 'semantic-ui-react';
import styles from './style.module.css'

const NumericInput = ({ placeholder = 'Enter a number', value, onChange, ...props }) => {
  // Handle the input change
  const handleChange = (e) => {
    const value = e.target.value;
    
    if (value === '') {
      onChange && onChange(e, { ...e, value: null });
      return;
    }
    // Allow empty value, numbers, and decimal point
    if (/^\d*\.?\d*$/.test(value)) {
      onChange && onChange(e, { ...e, value });
    } else {
      onChange && onChange(e, { ...e, value: null });
    }
  };

  // Handle keypress events to prevent invalid characters
  const handleKeyPress = (e) => {
    // Allow only numbers, decimal point, and control keys
    if (!/[\d.]/.test(e.key) && !e.ctrlKey && !e.metaKey) {
      e.preventDefault();
    }
    
    // Prevent multiple decimal points
    if (e.key === '.' && e.target.value.includes('.')) {
      e.preventDefault();
    }
  };

  // Handle paste events
  const handlePaste = (e) => {
    const pastedData = e.clipboardData.getData('text');
    if (!/^\d*\.?\d*$/.test(pastedData)) {
      e.preventDefault();
    }
  };

  return (
    <div className={styles.container}>
      <Input
        {...props}
        value={value}
        fluid
        placeholder={placeholder}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
        onPaste={handlePaste}
      />
    </div>
  );
};

export default NumericInput;